import QuinielazoService from "@/services/QuinielazoService";

export const namespaced = true;

export const state = {
	jugador: null,
	jugadores: [],
	feed: []
};

export const mutations = {
	SET_JUGADOR(state, jugador) {
		state.jugador = jugador;
    },
    SET_JUGADORES(state, jugadores) {
    	state.jugadores = jugadores;
    },
    NEW_FOLLOWER(state){
    	state.jugador.seguidores_count = state.jugador.seguidores_count + 1
    	//this._vm.$set(,state.jugador.seguidores_count + 1)
    },
    REMOVE_FOLLOWER(state){
    	state.jugador.seguidores_count = state.jugador.seguidores_count - 1
    	//this._vm.$set(,state.jugador.seguidores_count - 1)
    },
    SET_FEED(state, feed){
    	state.feed = feed
    }
};

export const actions = {
	fetchJugador({ commit, dispatch }, id) {
		QuinielazoService.getPlayer(id)
		.then(resp => {
			commit("SET_JUGADOR", resp.data);
		})
		.catch(err => {
			dispatch("notification/add",{
					type: "error",
					message:
					"Hubo un error " +
					(err.response.data.error
						? "<strong>" + err.response.data.error + "</strong>"
						: "")
			},{ root: true });
		});
	},
	newFollower({commit}){
		commit('NEW_FOLLOWER')
	},
	unFollow({commit}){
		commit('REMOVE_FOLLOWER')
	},
	getFeed({commit, dispatch}){
		QuinielazoService.getFeed()
		.then(resp => {
			commit('SET_FEED', resp.data)
		})
		.catch(err => {
			dispatch("notification/add",{
					type: "error",
					message:
					"Hubo un error al cargar el feed " +
					(err.response.data.error
						? "<strong>" + err.response.data.error + "</strong>"
						: "")
			},{ root: true });
		})
	},
	updateJugador({commit}, jugador){
		commit('SET_JUGADOR', jugador)
	}
};
